// extracted by mini-css-extract-plugin
module.exports = {"carouselBase":"styles_carouselBase__ay4Ym","carousel":"styles_carousel__jghBa","pagination":"styles_pagination__KE_gh"};